import { afterNextRender, ChangeDetectionStrategy, Component, Optional } from '@angular/core'

import { AuthService } from '@auth0/auth0-angular'

@Component({
  selector: 'app-sign-in',
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class SignInComponent {
  constructor(@Optional() private auth0Service: AuthService | null) {
    afterNextRender(() => this.auth0Service?.loginWithRedirect().subscribe())
  }
}
